import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";
import { rid } from "../../utils/shipinhao/utils";

export interface GetShipinhaoPostListParams extends ActiomCommonParams {
    lastBuff?: string; // 分页标记
    pageSize?: number; // 每页数量
    userpageType?: number; // 内容类型 12-图文 默认12
}

export interface PostListResponse {
    errCode: number;
    errMsg: string;
    data: {
        list: PostDetail[];
        totalCount: number;
        hasMore: boolean;
    };
}

export interface PostDetail {
    postId: string;
    title: string;
    createTime: number;
    status: number;
    coverUrl: string;
    readCount: number;
    likeCount: number;
    commentCount: number;
}

export type GetPostListAction = CommonAction<GetShipinhaoPostListParams, PostListResponse["data"]>;

export const getShipinhaoPostList: GetPostListAction = async (_task, params) => {
    // 验证 extraParam 是否存在
    if (!params.extraParam) {
        return response(400, "缺少 extraParam 参数", { list: [], totalCount: 0, hasMore: false });
    }

    if (!params.extraParam.fingerPrintDeviceId || !params.extraParam.aId || !params.extraParam.uin) {
        return response(400, "fingerPrintDeviceId、aId和uin不能为空", { list: [], totalCount: 0, hasMore: false });
    }

    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://channels.weixin.qq.com/micro/interaction/post",
        origin: "https://channels.weixin.qq.com",
        "content-type": "application/json",
        "finger-print-device-id": params.extraParam.fingerPrintDeviceId,
        "x-wechat-uin": params.extraParam.uin,
    };

    const http = new Http({
        headers,
    });

    const urlParams = new URLSearchParams({
        _aid: params.extraParam.aId,
        _rid: rid(),
        _pageUrl: "https://channels.weixin.qq.com/micro/interaction/comment",
    }).toString();

    const requestData = {
        pageSize: params.pageSize ?? 10,
        onlyUnread: false,
        needAllCommentCount: true,
        userpageType: params.userpageType ?? 12, // 图文
        forMcn: false,
        lastBuff: params.lastBuff || "",
        timestamp: Date.now().toString(),
        _log_finder_uin: "",
        _log_finder_id: params.extraParam?.finderUserName || "",
        rawKeyBuff: null,
        pluginSessionId: null,
        scene: 7,
        reqScene: 7,
    };

    const res = await http.api<PostListResponse>({
        method: "post",
        url: `https://channels.weixin.qq.com/micro/interaction/cgi-bin/mmfinderassistant-bin/post/post_list?${urlParams}`,
        data: requestData,
    });
    console.log(res, "-----res");

    const isSuccess = res?.errCode === 0;

    return response(isSuccess ? 0 : 414, res?.errMsg, res.data);
};
